import React, {Fragment} from 'react';
import { List, Datagrid, TextField, ImageField, DateField, SelectInput, EditButton, Filter, TextInput, useTranslate } from 'react-admin';
import BatchDeleteButton from '../../control/button/batch-delete-button';
import {SEAT_COVER_TYPE} from '../../util/constant'
import {ValidateField, LockField, AvatarField} from '../../control/field/index'

const BulkActionButtons = props => (
    <Fragment>
        {/* <BatchDeleteButton label="Supprimer" {...props} /> */}
    </Fragment>
);
const Title = ({ record }) => {
    const translate = useTranslate();
    return <span>{translate('resources.seat_cover_type.list')}</span>;
};

// const TypeTextField = ({ source, record = {}, label}) => {
//     const locationType = locationDict[record.type];
//     return <span class="MuiTypography-root MuiTypography-body2">{typeof(locationType) !== 'undefined' ? locationType.name : record.type}</span>;
// }
    
// TypeTextField.defaultProps = {
//     addLabel: true,
// };

const statusList = [
    {id: 0, name: 'Non-vérrouillé'},
    {id: 1, name: 'Vérrouillé'}
];

const ListFilter = ({ permissions, ...props })  => (
    <Filter {...props}>
        <TextInput label="Nom" source="name" alwaysOn resettable/>
        {/* <SelectInput label="État" source="is_locked" alwaysOn choices={statusList} 
        allowEmpty emptyText="Tous" emptyValue='-1' initialValue='-1'/> */}
        
    </Filter>
);

const ListFuelType = ({permissions, ...props}) => (
    <List title={<Title/>} {...props} 
        filters = {<ListFilter permissions={permissions} />} 
        bulkActionButtons={<BulkActionButtons />} exporter={false} resource="seat_cover_type"  filter={{type: SEAT_COVER_TYPE}}>
        <Datagrid rowClick="edit">
            <TextField source="name" label = "Nom"/>
            {/* <LockField source="locked" label="Vérouillage"/> */}
            <ValidateField source="is_locked" label='Verrouillé'/>
            {/* <EditButton/> */}
        </Datagrid>
    </List>
);

export default ListFuelType;

